import z from "zod";
import {
  HospitalityType,
  HospitalityTypes,
  RentalTag,
  RentalTags,
} from "../../types";

export const editFinancialInfoSchema = () =>
  z
    .object({
      contractSellingPrice: z.coerce.number().int().positive().optional(),
      actualSellingPrice: z.coerce.number().int().positive().optional(),
      forcastedRentalUnits: z.coerce.number().int().positive().optional(),
      rentalTag: z.enum(Object.keys(RentalTags) as [RentalTag]).optional(),
      hospitalityType: z
        .enum(Object.keys(HospitalityTypes) as [HospitalityType])
        .optional(),
    })
    .refine(
      (data) => {
        if (data.rentalTag === "hospitality") return !!data.hospitalityType;
        return true;
      },
      {
        message: "Hospitality type is required when rental type is Hospitality",
        path: ["hospitalityType"],
      }
    );
